import { render } from "./Quizz.vue?vue&type=template&id=dcc3f45e&scoped=true"
import script from "./Quizz.vue?vue&type=script&lang=js"
export * from "./Quizz.vue?vue&type=script&lang=js"

import "./Quizz.vue?vue&type=style&index=0&id=dcc3f45e&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc3f45e"]])

export default __exports__